import type { HTTPMethod } from "h3"
import type { $Fetch, FetchOptions } from "ofetch"

export default class HttpFactory<T> {
  protected $fetch: $Fetch

  constructor(fetcher: $Fetch) {
    this.$fetch = fetcher
  }

  /**
   * The HTTP client is utilized to control the process of making API requests.
   * @param method the HTTP method (GET, POST, ...)
   * @param path the endpoint url
   * @param payload the body data
   * @param options fetch options
   * @returns
   */
  request(method: HTTPMethod, path: string, payload: Record<string, any> = {}, options?: FetchOptions<"json">): Promise<T> {
    if (!path) throw new Error("Request path is required")

    const { token } = useAuth()

    const reqOpts: Record<string, any> = {
      method,
      headers: {
        Authorization: token?.value ?? null
      },
      responseType: "json"
    }

    if (["GET"].includes(method.toUpperCase())) reqOpts["query"] = reactive(payload)
    if (["POST", "PATCH", "PUT", "DELETE"].includes(method.toUpperCase())) reqOpts["body"] = reactive(payload)

    return this.$fetch<T>(path, {
      ...reqOpts,
      ...options
    } as any)
  }
}
